// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__Tge3c","icon":"Item_icon__9M75F","active":"Item_active__VBIUQ"};